import { useState, useMemo } from "react"
import { MOCK_ASSIGNED_EQUIPMENT, MOCK_AVAILABLE_EQUIPMENT } from "../constants/mockData"

const useEquipmentManagement = () => {
  const [assignedEquipment, setAssignedEquipment] = useState(MOCK_ASSIGNED_EQUIPMENT)
  const [availableEquipment, setAvailableEquipment] = useState(MOCK_AVAILABLE_EQUIPMENT)
  const [showAddEquipment, setShowAddEquipment] = useState(false)
  const [selectedCategories, setSelectedCategories] = useState([])

  const handleUnassign = (equipmentId) => {
    const equipment = assignedEquipment.find((eq) => eq.id === equipmentId)
    if (equipment) {
      setAssignedEquipment(assignedEquipment.filter((eq) => eq.id !== equipmentId))
      setAvailableEquipment([...availableEquipment, equipment])
    }
  }

  const handleAssign = (equipment) => {
    if (assignedEquipment.some((eq) => eq.id === equipment.id)) return
    setAssignedEquipment([...assignedEquipment, equipment])
    setAvailableEquipment(availableEquipment.filter((eq) => eq.id !== equipment.id))
  }

  const handleCategoryFilter = (values) => {
    setSelectedCategories(values)
  }

  const toggleAddEquipment = () => {
    setShowAddEquipment(!showAddEquipment)
  }

  const closeAddEquipment = () => {
    setShowAddEquipment(false)
  }

  const filteredAvailableEquipment = useMemo(() => {
    // Show all equipment if no categories selected or "all" is selected
    if (selectedCategories.length === 0 || selectedCategories.includes("all")) {
      return availableEquipment
    }
    // Filter by selected categories (excluding "all" if present)
    return availableEquipment.filter((eq) => selectedCategories.includes(eq.category))
  }, [availableEquipment, selectedCategories])

  return {
    assignedEquipment,
    availableEquipment,
    filteredAvailableEquipment,
    showAddEquipment,
    selectedCategories,
    handleUnassign,
    handleAssign,
    handleCategoryFilter,
    toggleAddEquipment,
    closeAddEquipment,
    setSelectedCategories
  }
}

export default useEquipmentManagement
